<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <div>
    <modal
      :visible="isVisible"
      :title="capitalize($t('actions.downloadScreens'))"
      :body="capitalize($t('messages.chooseAFileFormat'))"
      :button1-visible="true"
      :button1-caption="capitalize($t('actions.cancel'))"
      :button2-visible="false"
      @confirmed="isVisible = false"
      @cancelled="isVisible = false"
      >>
      <template #modal-after-form>
        <div class="flex-v-full">
          <div class="file-types">
            <div class="file-type">
              <a
                href="#"
                data-action-type="download-csv-file"
                @click="downloadSitesAsCSV">
                <icon-file-c-s-v />
              </a>
            </div>

            <div class="file-type">
              <a
                href="#"
                data-action-type="download-xlsx-file"
                @click="downloadSitesAsXLSX">
                <icon-file-x-l-s />
              </a>
            </div>
          </div>
        </div>
      </template>
    </modal>
  </div>
</template>

<script type="text/babel">
  import Excel from 'exceljs';
  import { capitalize } from 'vue';
  import { mapActions, mapGetters } from 'vuex';

  import { IconFileCSV, IconFileXLS } from '@/common/icons/monochrome';
  import DownloadUtils from '@/utils/DownloadUtils';
  import i18n from '@/vueI18n';

  export default {
    components: {
      IconFileCSV,
      IconFileXLS,
    },
    props: {
      name: {
        type: String,
      },
      units: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        isVisible: false,
      };
    },
    computed: {
      ...mapGetters(['membershipSettings']),
      columns() {
        return [
          capitalize(i18n.global.t('names.screenID', { n: 1 })),
          capitalize(i18n.global.t('names.screenName', { n: 1 })),
          capitalize(i18n.global.t('names.screenWidthPx', { n: 1 })),
          capitalize(i18n.global.t('names.screenHeightPx', { n: 1 })),
          ...(this.membershipSettings != null && this.membershipSettings.uiHideLatitudeLongitude
            ? []
            : [capitalize(i18n.global.t('names.screenLatitude', { n: 1 }))]),
          ...(this.membershipSettings != null && this.membershipSettings.uiHideLatitudeLongitude
            ? []
            : [capitalize(i18n.global.t('names.screenLongitude', { n: 1 }))]),
          capitalize(i18n.global.t('messages.screenNetwork')),
          capitalize(i18n.global.t('names.siteID', { n: 1 })),
          capitalize(i18n.global.t('names.siteName', { n: 1 })),
          capitalize(i18n.global.t('names.siteLocationCity', { n: 1 })),
          capitalize(i18n.global.t('names.siteRegion', { n: 1 })),
        ];
      },
      dataRows() {
        const units = this.units.map((u) => [
          u.externalID,
          u.name,
          u.screenWidth,
          u.screenHeight,
          ...(this.membershipSettings != null && this.membershipSettings.uiHideLatitudeLongitude ? [] : [u.latitude]),
          ...(this.membershipSettings != null && this.membershipSettings.uiHideLatitudeLongitude ? [] : [u.latitude]),
          u.networkName,
          u.siteExternalID,
          u.siteName,
          u.city,
          u.region,
        ]);
        return units;
      },
    },
    methods: {
      ...mapActions('orgApp', ['getLocations']),
      capitalize(text) {
        return capitalize(text);
      },
      show() {
        this.isVisible = true;
      },
      setupDownload() {
        const workbook = new Excel.Workbook();

        workbook.views = [
          {
            x: 0,
            y: 0,
            width: 30000,
            height: 20000,
            firstSheet: 0,
            activeTab: 1,
            visibility: 'visible',
          },
        ];

        const sheet = workbook.addWorksheet(i18n.global.t('names.screen', { n: 2 }));
        const baseColumnWidth = 10;
        sheet.getColumn(1).width = 1 * baseColumnWidth;
        sheet.getColumn(2).width = 2.4 * baseColumnWidth;
        sheet.getColumn(3).width = 1.4 * baseColumnWidth;
        sheet.getColumn(4).width = 1.4 * baseColumnWidth;
        sheet.getColumn(5).width = 1.4 * baseColumnWidth;
        sheet.getColumn(6).width = 1.4 * baseColumnWidth;
        sheet.getColumn(7).width = 2 * baseColumnWidth;
        sheet.getColumn(8).width = 1 * baseColumnWidth;
        sheet.getColumn(9).width = 2.4 * baseColumnWidth;
        sheet.getColumn(10).width = 2 * baseColumnWidth;
        sheet.getColumn(11).width = 2 * baseColumnWidth;

        sheet.addRow(this.columns);
        this.dataRows.forEach((x) => {
          sheet.addRow(x);
        });

        return workbook;
      },
      downloadSitesAsCSV() {
        const workbook = this.setupDownload();

        workbook.csv.writeBuffer().then((data) => {
          const blob = new window.Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          const filename = this.name != null && this.name.trim() !== '' ? `${this.name} - screens.csv` : 'screens.csv';
          DownloadUtils.saveBlobToFile(blob, filename);
        });
        this.isVisible = false;
      },
      downloadSitesAsXLSX() {
        const workbook = this.setupDownload();

        workbook.xlsx.writeBuffer().then((data) => {
          const blob = new window.Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          const filename =
            this.name != null && this.name.trim() !== '' ? `${this.name} - screens.xlsx` : 'screens.xlsx';
          DownloadUtils.saveBlobToFile(blob, filename);
        });
        this.isVisible = false;
      },
    },
  };
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables' as *;

  .file-types {
    display: flex;
    justify-content: center;

    .file-type {
      display: flex;
      flex-direction: column;
      align-content: center;
      margin: 0 2rem;

      a {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 2.4rem;
        border: solid 1px #0074ff;
        border-radius: 6px;
        background-color: #0074ff05;

        &:hover {
          background-color: #fff;
        }
      }

      svg {
        stroke: var(--secondaryColor);
        fill: var(--secondaryColor);

        width: 6.4rem;
        height: 6.4rem;
        margin-right: 0.1rem;
        margin-bottom: 0.6rem;
      }

      &:first-of-type {
        svg {
          margin-left: 0.1rem;
          margin-right: 0;
        }
      }
    }
  }
</style>
